/* Bluorng PDP behaviour ----------------------------------------------------
   The imported product descriptions carry the source site's own markup:
   .product-details-container blocks holding title/body pairs, an inline
   .size-body-container table, and a .sizechart modal with an IN/CM toggle
   that ships with style="display:none" and no code behind it.

   This wires that markup up the way the source does: the title/body pairs
   are regrouped into the source's three tabs — "Details & Description",
   "Washcare", "Shipping" — in an accordion box placed UNDER the info card,
   and the size guide moves behind a chip that opens the modal.
   Everything is defensive — if the markup is not there, nothing happens.
-------------------------------------------------------------------------- */
(function () {
  'use strict';

  function collectSections(root) {
    // Sections arrive fragmented: a title-only block can be followed by a
    // body-only block in a different container. Walk in document order and
    // stitch them back together.
    var sections = [];
    var current = null;
    root.querySelectorAll('.product-details-container .product-details').forEach(function (block) {
      var title = block.querySelector('.product-details-title');
      var desc = block.querySelector('.product-details-desc');
      if (title) {
        current = { label: title.textContent.trim(), bodies: [] };
        sections.push(current);
      }
      if (desc) {
        if (!current) {
          current = { label: '', bodies: [] };
          sections.push(current);
        }
        current.bodies.push(desc.innerHTML);
      }
    });
    return sections.filter(function (s) { return s.label && s.bodies.length; });
  }

  // One line per paragraph, list item, or <br>-separated run.
  function linesFrom(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var lines = [];
    var nodes = tmp.querySelectorAll('p, li');
    if (!nodes.length) nodes = [tmp];
    nodes.forEach(function (node) {
      node.innerHTML.split(/(?:<br\s*\/?>\s*)+/i).forEach(function (part) {
        var t = part.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
        if (t) lines.push(t);
      });
    });
    return lines;
  }

  function esc(s) {
    return s.replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function heading(t) { return '<h6 class="blu-acc__title">' + esc(t) + '</h6>'; }
  function list(lines) {
    return '<div class="blu-acc__body"><ul class="blu-acc__list">'
      + lines.map(function (l) { return '<li>' + esc(l) + '</li>'; }).join('')
      + '</ul></div>';
  }
  function paras(lines) {
    return '<div class="blu-acc__body">'
      + lines.map(function (l) { return '<p>' + esc(l) + '</p>'; }).join('')
      + '</div>';
  }

  // The source's accordion: Details (a list) and Description (paragraphs)
  // share the first tab; care lines get their own; shipping its own.
  function groupSections(sections) {
    var pick = function (re) {
      return sections.filter(function (s) { return re.test(s.label); }).reduce(function (acc, s) {
        return acc.concat(linesFrom(s.bodies.join('')));
      }, []);
    };
    var details = pick(/detail/i);
    var description = pick(/descri/i);
    var wash = pick(/wash|care/i);
    var shipping = pick(/ship|deliver/i);

    // The imported details list carries the care line inline; the source
    // keeps it in its own tab.
    details = details.filter(function (l) {
      if (/\bwash/i.test(l)) { wash.push(l); return false; }
      return true;
    });

    var tabs = [];
    if (details.length || description.length) {
      var html = '';
      if (details.length) html += heading('Details') + list(details);
      if (description.length) html += heading('Description') + paras(description);
      tabs.push({ label: 'Details & Description', html: html });
    }
    if (wash.length) tabs.push({ label: 'Washcare', html: list(wash) });
    if (shipping.length) tabs.push({ label: 'Shipping', html: list(shipping) });

    // Anything the source never had keeps its own tab so nothing is lost.
    sections.forEach(function (s) {
      if (/detail|descri|wash|care|ship|deliver/i.test(s.label)) return;
      tabs.push({ label: s.label, html: list(linesFrom(s.bodies.join(''))) });
    });
    return tabs;
  }

  function buildTabs(host, tabs) {
    var wrap = document.createElement('div');
    wrap.className = 'blu-tabs';

    var strip = document.createElement('div');
    strip.className = 'blu-tabs__strip';
    strip.setAttribute('role', 'tablist');

    var panels = document.createElement('div');
    panels.className = 'blu-tabs__panels';

    tabs.forEach(function (t, i) {
      var id = 'blu-tab-' + i;

      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'blu-tabs__tab';
      tab.textContent = t.label;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      tab.setAttribute('aria-controls', id);
      strip.appendChild(tab);

      var panel = document.createElement('div');
      panel.className = 'blu-tabs__panel';
      panel.id = id;
      panel.setAttribute('role', 'tabpanel');
      panel.innerHTML = t.html;
      panel.hidden = i !== 0;
      panels.appendChild(panel);

      tab.addEventListener('click', function () {
        strip.querySelectorAll('.blu-tabs__tab').forEach(function (b, j) {
          b.setAttribute('aria-selected', String(j === i));
        });
        panels.querySelectorAll('.blu-tabs__panel').forEach(function (p, j) {
          p.hidden = j !== i;
        });
      });
    });

    wrap.appendChild(strip);
    wrap.appendChild(panels);
    host.appendChild(wrap);
  }

  function wireSizeGuide(scope) {
    var modal = scope.querySelector('.sizechart');
    var inline = scope.querySelector('.size-body-container');
    if (!modal) return;

    modal.removeAttribute('style');
    modal.classList.add('blu-sizechart');
    modal.hidden = true;
    if (inline) inline.hidden = true;
    // Out of the (soon hidden) description block, so it can still open.
    document.body.appendChild(modal);

    var pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'blu-sizeguide-pill';
    pill.textContent = 'Size Guide';

    // Anchored to the info card by CSS; inserting it beside the picker keeps
    // it in reading order.
    var anchor = scope.querySelector('.variant-picker');
    if (anchor && anchor.parentElement) {
      anchor.parentElement.insertBefore(pill, anchor);
    } else {
      scope.insertBefore(pill, scope.firstChild);
    }

    function open() { modal.hidden = false; document.body.style.overflow = 'hidden'; }
    function close() { modal.hidden = true; document.body.style.overflow = ''; }

    pill.addEventListener('click', open);
    var overlay = modal.querySelector('.sizechart-overlay');
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    var closer = document.createElement('button');
    closer.type = 'button';
    closer.className = 'blu-sizechart__close';
    closer.setAttribute('aria-label', 'Close size guide');
    closer.textContent = '×';
    closer.addEventListener('click', close);
    var header = modal.querySelector('.size-chart-header');
    if (header) header.appendChild(closer);

    // IN / CM toggle ships in the markup with nothing behind it.
    var toggles = modal.querySelectorAll('.size-chart-toggle [data-unit]');
    var tables = modal.querySelectorAll('[data-table]');
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var unit = btn.getAttribute('data-unit');
        toggles.forEach(function (b) { b.classList.toggle('active', b === btn); });
        tables.forEach(function (t) {
          t.classList.toggle('hidden', t.getAttribute('data-table') !== unit);
        });
      });
    });
  }

  function init() {
    try {
      var scope = document.querySelector('main .product-details.sticky-content--desktop')
        || document.querySelector('main .product-details');
      if (!scope || scope.querySelector('.blu-tabs')) return;

      var card = scope.querySelector(':scope > .group-block') || scope;
      var containers = scope.querySelectorAll('.product-details-container');
      var sections = collectSections(scope);

      wireSizeGuide(scope);

      if (sections.length) {
        // The whole description block goes: its content now lives in the tabs.
        var block = containers[0].closest('.text-block');
        if (!block) {
          block = containers[0];
          while (block.parentElement && block.parentElement !== card
            && !block.parentElement.classList.contains('group-block-content')) {
            block = block.parentElement;
          }
        }
        if (block && block !== card && !block.classList.contains('group-block-content')) {
          block.classList.add('blu-hidden');
        }
        containers.forEach(function (c) { c.hidden = true; });
        buildTabs(scope, groupSections(sections));
      }
    } catch (e) {
      /* never break the page over presentation */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
